export const POST_REGISTER_USER = (invitacion_code) => `https://khv19r7h32.execute-api.us-east-1.amazonaws.com/development/invitations/${invitacion_code}`;
export const GET_INFO_USER = (code) => `https://khv19r7h32.execute-api.us-east-1.amazonaws.com/development/invitations/${code}`;

//PREPROD
export const POST_REGISTER_USER_PREPROD = (invitacion_code) => `https://5q7lou0v9k.execute-api.us-west-2.amazonaws.com/preprod/invitations/${invitacion_code}`;
export const GET_INFO_USER_PREPROD = (code) => `https://5q7lou0v9k.execute-api.us-west-2.amazonaws.com/preprod/invitations/${code}`;

// PROD
export const POST_REGISTER_USER_PROD = (invitacion_code) => `https://9qvogtmgcb.execute-api.us-east-1.amazonaws.com/prod/invitations/${invitacion_code}`;
export const GET_INFO_USER_PROD = (code) => `https://9qvogtmgcb.execute-api.us-east-1.amazonaws.com/prod/invitations/${code}`;